import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { BannerContainer } from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/modalBanner.styles';

const EmployeeViewConsentGivenBanner = () => (
  <BannerContainer themeColor={ThemeColorType.iconGray}>
    <Text14 themeColor={ThemeColorType.white} semiBold>
      {gettext('You consented to the timesheet edits.')}
    </Text14>

    <div>
      <Text14 themeColor={ThemeColorType.white} semiBold>
        {gettext("Pending manager's approval.")}
      </Text14>
    </div>
  </BannerContainer>
);

export default EmployeeViewConsentGivenBanner;
